module.exports = __webpack_public_path__ + "img/subtitle-3.f3853204.svg";